import React from 'react';
import Form from 'react-bootstrap/Form';
import {FormikProps} from 'formik';
import SearchSelect from '@/components/search_select/SearchSelect';
import {buildURL} from '@/utils/urlBuilder';
import i18n from 'i18n';

interface ActionRerouteEmailsFormValues {
    params: {
        accountId?: number;
        folderPath?: string[];
    };
}

interface ActionRerouteEmailsFormFieldsProps {
    formik: FormikProps<ActionRerouteEmailsFormValues>;
}

const ActionRerouteEmailsFormFields: React.FC<ActionRerouteEmailsFormFieldsProps> = React.memo((
    {
        formik,
    },
) => {

    return (
        <>
            <Form.Group className="mb-3" controlId="params.accountId" >
                <Form.Label>{i18n.t('jt_select_the_account_where_emails_will_be_redirected_to.text')}</Form.Label>
                <SearchSelect
                    optionsUrl={window.URLS.emailFetchAccountsResource}
                    formik={formik}
                    fieldName="params.accountId"
                    valueName="id"
                    labelName="email"
                />
                <Form.Control.Feedback
                    type="invalid"
                    style={{
                        display: formik.touched.params?.accountId && formik.errors.params?.accountId ? 'block' : 'none',
                    }}
                >
                    {formik.errors.params?.accountId}
                </Form.Control.Feedback>
            </Form.Group >

            <Form.Group className="mb-3" controlId="params.folderPath" >
                <Form.Label>{i18n.t('jt_select_the_destination_folder_where_emails_will_be_moved_to.text')}</Form.Label>
                <SearchSelect
                    optionsUrl={
                        buildURL('emailFetchAccountFoldersResource', {
                            obj_id: formik.values.params?.accountId || 0
                        })
                    }
                    formik={formik}
                    isDisabled={!formik.values.params?.accountId}
                    selectKey={formik.values.params?.accountId}
                    fieldName="params.folderPath"
                    getLabel={(value: string[]) => value.join(' -> ')}
                />
                <Form.Control.Feedback
                    type="invalid"
                    style={{
                        display: formik.touched.params?.folderPath && formik.errors.params?.folderPath
                            ? 'block'
                            : 'none',
                    }}
                >
                    {formik.errors.params?.folderPath}
                </Form.Control.Feedback>
            </Form.Group >
        </>
    );
});

ActionRerouteEmailsFormFields.displayName = 'ActionRerouteEmailsFormFields';

export default ActionRerouteEmailsFormFields; 